import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { formatDate, formatTime } from '../../util';

@Component({
    name: 'AndonComponent',
    components: {
    }
})
export default class AndonComponent extends Vue {
    @Prop({ required: true })
    readonly setting!: string;

    private data: { settingName: string, title: string, target: number, actual: number, previous: number, targetDescription: string, actualDescription: string, previousDescription: string, imageUrl: string }
        = { settingName: "Loading ...", title: 'Loading ...', target: -1, actual: -1, previous: -1, targetDescription: '', actualDescription: '', previousDescription: '', imageUrl: '' };
    private lastUpdate: Date = new Date();

    mounted(): void {
        this.initSignalR();
    }

    private initSignalR(): HubConnection {
        const connection = new HubConnectionBuilder()
            .withUrl("andonhub")
            .build();
        connection.on("AndonRefresh", (setting: string, json) => {
            if (setting.toLocaleLowerCase() === this.setting.toLocaleLowerCase()) {
                this.data = JSON.parse(json);
                this.lastUpdate = new Date();
            }
        });
        connection.onclose(() => this.reconnectSignalR(connection)); // Restart connection after 5 seconds.
        connection.start().catch(err => {
            console.error(err);
            this.reconnectSignalR(connection);
        });
        return connection;
    }

    private reconnectSignalR(connection): void {
        setTimeout(() => {
            connection.start().catch(err => {
                console.error(err);
                this.reconnectSignalR(connection);
            });
        }, 5000);
    }

    private formatDate(d: Date | null): string | null {
        return d && formatDate(d);
    }

    private formatTime(d: Date | null): string | null {
        return d && formatTime(d);
    }
}